import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 4h10a2 2 0 0 1 2 2v10m-.584 3.412a2 2 0 0 1 -1.416 .588h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.052 .586 -1.414","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconSquareOff = createReactComponent('outline', 'square-off', 'SquareOff', __iconNode);

export default IconSquareOff;